import { render, staticRenderFns } from "./ClinicianRegistrationBetaInfo.vue?vue&type=template&id=5b00c32d&scoped=true&"
import script from "./ClinicianRegistrationBetaInfo.vue?vue&type=script&lang=js&"
export * from "./ClinicianRegistrationBetaInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianRegistrationBetaInfo.vue?vue&type=style&index=0&id=5b00c32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00c32d",
  null
  
)

export default component.exports